import ApiManager from "../api/ApiManager";
import { useAuth } from "../store/AuthContext/AuthContext";

export function useSubscriptionHandler() {
  const api = new ApiManager();
  const { getCookie, setIsSubbed } = useAuth(); // 👈 aggiunto
  const id_token = getCookie("id_token");

  const sendSubscription = async (paypalData) => {
    console.log("paypal response", paypalData);

    try {
      const response = await api.post(
        "/sub",
        {
          subscribed: true,
          plan_duration_days: 30,
        },
        {
          headers: {
            Authorization: `Bearer ${id_token}`,
          },
        }
      );

      console.log("Subscription response:", response);
      
      // 👇 aggiorna lo stato globale
      setIsSubbed(true);

      return response;
    } catch (error) {
      console.error("Subscription error:", error);
    }
  };

  return { sendSubscription };
}
